import React from "react";
import "./Camp.css";

function Camp() {
  return (
    <div className="camp">
      <h4>Special Events</h4>
      <hr></hr>
      <ul>
      <li className="a">
          <a href="https://drive.google.com/file/d/18HoI7V5CaFprU7Ai9woFhm2-N8Oc8EG-/view?usp=drive_link" className="a" >NSS KARNATAKA 2024</a>
        </li>
        <li className="a">
          <a href="https://drive.google.com/file/d/1DSwqsg1PdY7sv7f-Lg5tJ2QufFJ-nZae/view?usp=sharing" className="a" >NSS SPECIAL CAMP 2022</a>
        </li>
        <li className="a">
          <a href="https://drive.google.com/file/d/165XMUGLdoY0zuDcVHRvET1QwKVvtRW03/view?usp=sharing" className="a">NIC ODISHA 2022</a>
        </li>
        <li className="a">
          <a href="https://drive.google.com/file/d/1fooLmcIQNE-4uUi3eiwtfw4vZE0KOfbh/view?usp=sharing" className="a">NIC TELANGANA 2022</a>
        </li>
        <li className="a">
          <a href="https://drive.google.com/file/d/1OaSWvMv_ItPgAZ4s2uex39TzRvrclKYO/view?usp=sharing" className="a">NIC HARYANA 2021</a>
        </li>
        <li className="a">
          <a href="https://drive.google.com/file/d/1CKMt7pUozmsdlr5tAGDOcjhC7QXvohIB/view?usp=drive_link" className="a">NIC EAST GODAVARI 2020</a>
        </li>
        <li className="a">
          <a href="https://drive.google.com/file/d/1Gte4K8re5VLeEawG-Ou0h7Xlqj8aixTY/view?usp=sharing" className="a">NIC JAIPUR 2020</a>
        </li>
        
      </ul>
    </div>
  );
}

export default Camp;
